// @ts-nocheck
// Simplified Monday app entry for the monorepo. Skips the standalone setup
// wizard + login (unified auth handles that). Boots straight into the
// board UI assuming the user is already authenticated.

import { useEffect, useState } from "react";
import { StoreProvider, useAppState, useDispatch } from "./store";
import * as api from "./api";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import BoardView from "./components/BoardView";
import "./App.css";

function MondayInner() {
  const state = useAppState();
  const dispatch = useDispatch();
  const [bootError, setBootError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        // /api/monday/auth/me returns the user record (auto-created if missing).
        const me = await api.getMe();
        dispatch({ type: "SET_USER", user: me.user });

        const wsRes = await api.getWorkspaces();
        dispatch({ type: "SET_WORKSPACES", workspaces: wsRes.workspaces });

        if (wsRes.workspaces.length > 0) {
          const wsId = wsRes.workspaces[0].id;
          dispatch({ type: "SET_ACTIVE_WORKSPACE", id: wsId });
          const [boardsRes, foldersRes] = await Promise.all([
            api.getBoards(wsId),
            api.getFolders(wsId),
          ]);
          dispatch({ type: "SET_BOARDS",  boards:  boardsRes.boards });
          dispatch({ type: "SET_FOLDERS", folders: foldersRes.folders });
        }
        dispatch({ type: "SET_LOADING", loading: false });
      } catch (e) {
        setBootError(e instanceof Error ? e.message : String(e));
        dispatch({ type: "SET_LOADING", loading: false });
      }
    })();
  }, []);

  if (bootError) {
    return (
      <div className="card p-6 m-6">
        <div className="text-base font-semibold text-rose-700">Contacts couldn't boot</div>
        <div className="mt-1 text-sm text-slate-600">{bootError}</div>
      </div>
    );
  }
  if (state.loading) {
    return <div className="p-6 text-sm text-slate-400">Loading boards…</div>;
  }

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-area">
        <Header />
        <div className="main-content">
          {state.activeBoardId ? (
            <BoardView />
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">
                <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#c3c6d4" strokeWidth="1">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <line x1="3"  y1="9"  x2="21" y2="9" />
                  <line x1="9"  y1="21" x2="9"  y2="9" />
                </svg>
              </div>
              <h2>Welcome to Contacts</h2>
              <p>Select a board from the sidebar or create a new one to get started.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function MondayApp() {
  return (
    <StoreProvider>
      <MondayInner />
    </StoreProvider>
  );
}
